/* eslint-disable max-len */

import LinkQuestion from 'images/coin-pages/questions/chainlink.svg'

import { ICoinPageData } from '../types'

export const linkPage: ICoinPageData = {
  title: 'coin_604',
  description: 'coin_605',
  metaDescription: 'coin_link_meta_desc',
  metaTitle: 'coin_link_meta_title',
  h1: (t, _, replacePlaceholders) => (
    <span
      dangerouslySetInnerHTML={{ __html: replacePlaceholders(t('get_instant_coin_loan'), { coin: 'ChainLink Token' }) }}
    />
  ),
  questionsBlock: {
    image: LinkQuestion,
    questions: [
      {
        title: 'coin_607',
        answer: 'coin_608',
      },
      {
        title: 'coin_609',
        answer: 'coin_610',
      },
      {
        title: 'coin_611',
        answer: 'coin_612',
      },
      {
        title: 'coin_613',
        answer: 'coin_614',
      },
    ],
  },
  whatIs: {
    text: ['coin_617'],
    paragraphs: [
      {
        title: 'coin_615',
        text: ['coin_618'],
      },
      {
        title: 'coin_616',
        text: ['coin_619'],
      },
    ],
    blogCards: [
      {
        link: 'https://coinrabbit.io/blog/how-to-get-an-instant-loan-using-your-chainlink/',
        image: 'https://coinrabbit.io/blog/wp-content/uploads/2022/01/integration-91CR_LQ-1.png',
        imageAlt: 'Chainlink Token (LINK) review 5',
      },
      {
        link: 'https://coinrabbit.io/blog/what-is-crypto-lending-and-how-does-it-work/',
        image:
          'https://cdn.shortpixel.ai/client/q_lossless,ret_img,w_1185/https://coinrabbit.io/blog/wp-content/uploads/2021/07/photo_2021-07-23_20-28-31.jpg',
        imageAlt: 'Chainlink Token (LINK) review 6',
      },
      {
        link: 'https://coinrabbit.io/blog/how-crypto-assets-are-secured/',
        image: 'https://coinrabbit.io/blog/wp-content/uploads/2021/08/integration-52CR_LQ.png',
        imageAlt: 'Chainlink Token (LINK) review 7',
      },
    ],
  },
}
